import { SIDE_PANEL_MAX_IMAGE_LIMIT } from './constants';
import { getImageThumbnailUrl } from 'src/utils/getImageThumbnailUrl';
import { MEDIA_TYPES } from 'src/utils/constants';
import { SidePanelLastMask } from './DesktopImageComponent.styles';
import { MediaContainer } from 'src/components/ProductMediaRenderer/MediaContainer';
import { PlayIcon } from 'src/assets/svgExports/PlayIcon';

export const SidePanelImages = ({
  sidePanelImages,
  thumbnailImageDimensions,
  mainImage,
  handleSidePanelViewMore,
  handleSidePanelImage,
  returnIndexOnSelect = false,
}) => {
  if (!sidePanelImages?.length) {
    return null;
  }

  const showLimitedImages =
    !!handleSidePanelViewMore && sidePanelImages?.length > SIDE_PANEL_MAX_IMAGE_LIMIT;

  const showPlayIcon = (item, index) =>
    (item?.media_type === MEDIA_TYPES.YOUTUBE_VIDEO ||
      item?.media_type === MEDIA_TYPES.VIDEO) &&
    (!showLimitedImages || index !== SIDE_PANEL_MAX_IMAGE_LIMIT);

  const imagesToShow = showLimitedImages
    ? sidePanelImages.slice(0, SIDE_PANEL_MAX_IMAGE_LIMIT + 1)
    : sidePanelImages;

  function _renderCustomIconOverMedia(index) {
    return (
      showLimitedImages &&
      index === SIDE_PANEL_MAX_IMAGE_LIMIT && (
        <SidePanelLastMask
          thumbnailImageDimensions={thumbnailImageDimensions}
          className="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"
          onClick={handleSidePanelViewMore}
        >
          + {sidePanelImages?.length - SIDE_PANEL_MAX_IMAGE_LIMIT}
        </SidePanelLastMask>
      )
    );
  }

  return imagesToShow.map((item, index) => (
    <MediaContainer
      key={`${item?.image_id}-${index}-index-side-panel-images`}
      width={thumbnailImageDimensions?.width}
      containerClasses="tw-mb-[16px] tw-cursor-pointer tw-mr-[16px] md:tw-mr-[0px] tw-flex-shrink-0"
      onClick={() => handleSidePanelImage(returnIndexOnSelect ? index : item)}
      isSelected={mainImage?.thumbnail_url === item?.thumbnail_url}
    >
      <img
        className="tw-h-full tw-w-full tw-object-contain"
        src={getImageThumbnailUrl(item, item?.media_type === MEDIA_TYPES.VIDEO)}
      />
      {showPlayIcon(item, index) && (
        <span className="tw-absolute tw-left-[50%] tw-top-[50%] tw-flex -tw-translate-x-1/2 -tw-translate-y-1/2">
          <PlayIcon />
        </span>
      )}
      {_renderCustomIconOverMedia(index)}
    </MediaContainer>
  ));
};
